import { defineComponent as _defineComponent } from 'vue'
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';
import {
  AccountStates,
  EAccountStatusAction
} from '@/modules/common/services/http/account';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ButtonPrimary, Heading } from '@warrenbrasil/nebraska-web';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeAccountStatus',
  props: {
  accountStatusResponse: {
    type: Object as () => AccountStates,
    required: true
  }
},
  setup(__props) {

const props = __props;


const storeHref = ref('');
const button = props.accountStatusResponse.accountStatus.button;

function mountStoreHref() {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/#/')[0];
  storeHref.value = `${baseUrl}/#/mobile`;
}

const isMobile = ref(false);

function checkIfMobile() {
  isMobile.value = window.innerWidth <= 768;
}

onMounted(() => {
  checkIfMobile();
});

const routeMapping: Record<
  EAccountStatusAction,
  { mobile: string; desktop: string; withHost?: boolean }
> = {
  [EAccountStatusAction.FacematchRejected]: {
    mobile: 'states/face-match',
    desktop: 'states/face-match'
  },
  [EAccountStatusAction.FacematchRequired]: {
    mobile: 'states/face-match',
    desktop: 'states/face-match'
  },
  [EAccountStatusAction.FacematchError]: {
    mobile: 'states/facematch-error',
    desktop: 'states/facematch-error'
  },
  [EAccountStatusAction.RegisterAddressReview]: {
    mobile: 'states/register-address-review',
    desktop: 'states/register-address-review'
  },
  [EAccountStatusAction.RegisterDocuments]: {
    mobile: 'register-documents/document',
    desktop: 'documents-info'
  },
  [EAccountStatusAction.RegisterRejected]: {
    mobile: 'states/register-rejected',
    desktop: 'states/register-rejected'
  },
  [EAccountStatusAction.RegisterAnalysis]: {
    mobile: 'states/register-analysis',
    desktop: 'states/register-analysis'
  },
  [EAccountStatusAction.RegisterFinancialLife]: {
    mobile: 'financial-life/profession',
    desktop: 'financial-info'
  },
  [EAccountStatusAction.RegisterPersonal]: {
    mobile: 'personal-info/nationality',
    desktop: 'personal-info'
  },
  [EAccountStatusAction.RegisterMinorsPending]: {
    mobile:
      'https://faq.warren.com.br/hc/pt-br/articles/215877547-Posso-abrir-conta-para-o-meu-filho-Existe-idade-m%C3%ADnima',
    desktop:
      'https://faq.warren.com.br/hc/pt-br/articles/215877547-Posso-abrir-conta-para-o-meu-filho-Existe-idade-m%C3%ADnima',
    withHost: true
  }
};

const buttonHref = computed(() => {
  const { domain, platform } = getDomainAndPlatform();

  if (button?.action) {
    const route = routeMapping[button?.action][platform];
    return routeMapping[button?.action].withHost
      ? route
      : `/onboarding/${domain}/${platform}/${route}`;
  }

  return '';
});

onMounted(() => {
  mountStoreHref();
});

return { __sfc: true,props, storeHref, button, mountStoreHref, isMobile, checkIfMobile, routeMapping, buttonHref, NebraskaColors, BaseText, ButtonPrimary, Heading }
}

})